
import get from 'lodash/get';
import { ATTRIBUTE_TYPE, BLACKLIST_ATTRIBUTE } from '@/constants/global';
// TODO:BRO-1276: import DTacoRating from '@appsumo/dorado-nuxt';
import TacoRating from '../utilities/TacoRating.vue';
import ProductsMainImage from './carousel/ProductsMainImage.vue';
import PDPPricingCard from './PDPPricingCard.vue';
import PDPTldr from './PDPTldr.vue';
import ProductsAtGlance from '../products/at-a-glance/ProductsAtGlance.vue';
import DealTermsAndFeatures from '../products/terms-and-features/DealTermsAndFeatures.vue';
import ListingTypeLogo from './ListingTypeLogo.vue';
import { LISTING_TYPES_WITH_LOGO } from '~/constants/listing-types';
import WishlistsButton from '../wishlists/Button.vue';
import ShareModal from '../common/ShareModal.vue';
import { getUtmParamsForSocialShare } from '../../util/global';

export default {
  LISTING_TYPES_WITH_LOGO,
  components: {
    ProductsMainImage,
    PDPPricingCard,
    PDPTldr,
    TacoRating,
    DealTermsAndFeatures,
    ListingTypeLogo,
    WishlistsButton,
    ShareModal,
    ProductsAtGlance,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    // TODO temp user object to be replaced by this.$store.state.session.user
    user: {
      type: Object,
      required: true,
    },
  },
  async fetch() {
    this.showShareModal = await this.$experiments.enroll('pdp-show-share-modal') === 'enabled';
  },
  data() {
    return {
      isPricingCardEmailSubmitted: false,
      showShareModal: false,
    };
  },
  computed: {
    hasListingTypeLogo() {
      return !!this.$options.LISTING_TYPES_WITH_LOGO.includes(this.deal.listing_type);
    },
    story() {
      return get(this, ['deal', 'products', 0, 'story'], {});
    },
    buyButton() {
      return this.deal.buy_button || {};
    },
    images() {
      if (this.deal.media_url) {
        return [
          {
            alt_text: 'Featured image',
            content: '',
            description: '',
            image: this.deal.media_url,
          },
          ...this.story?.images || [],
        ];
      }
      return this.story?.images || [];
    },
    planTypeText() {
      let textStr = '';
      for (let i = 0; i < this.deal.unique_plan_types.length; i += 1) {
        const typeArr = this.deal.unique_plan_types[i];
        if (typeArr[0] === 'One Time Purchase') {
          textStr += 'Lifetime deal';
        } else if (typeArr[0] === 'Limited License') {
          textStr += `${typeArr[2]} ${typeArr[1]} DEAL`;
        } else {
          textStr += typeArr[0];
        }
        if (i < this.deal.unique_plan_types.length - 1) {
          textStr += ' & ';
        }
      }
      return textStr;
    },
    isActiveDeal() {
      return !this.deal.stage_details.is_inactive_indefinitely;
    },
    showTldr() {
      return !!this.story?.highlights?.length && !this.deal.is_info;
    },
    currentUser() {
      return this.$store.state.session.user;
    },
    wishlistsCount() {
      return this.$store.getters['wishlists/wishlistsCount'];
    },
    wishlistExperiment() {
      return this.$store.getters['wishlists/wishlistExperiment'];
    },
    showWishlists() {
      return !!(this.currentUser && this.wishlistExperiment === 'enabled' && !this.deal.is_info);
    },
    attributes() {
      return this.deal
        .attributes?.filter((attribute) => {
          if (BLACKLIST_ATTRIBUTE.includes(attribute.slug)) {
            return false;
          }

          // for boolean types filter only ones with values: true
          return !(attribute.type === ATTRIBUTE_TYPE.BOOLEAN && !attribute.values);
        });
    },
    socialParams() {
      return getUtmParamsForSocialShare(this.deal, this.currentUser?.id);
    },
    shareableLink() {
      if (process.client) {
        return `${window.location.origin}${this.deal.get_absolute_url}`;
      }

      return '';
    },
  },
  methods: {
    sentenceCase(str) {
      return str.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase());
    },
    onEmailSubmitted() {
      this.isPricingCardEmailSubmitted = true;
    },
  },
};
